export function getError(err)
  {
    let error = (err && err.response && err.response.data && err.response.data.error);
    if (!error) {

        console.log({ status: err.response && err.response.status });
        if (err.response && err.response.status === 403) 
            error = "Keine Berechtigung.";
        else if (err.response && err.response.status === 401)
            error = "Bitte einloggen.";
        else {
            error = (err.toString ? err.toString() : "");
            if (err.response && err.response.statusText) {
                error += "(" + err.response.statusText + ")";
            }
        }
    }
    return error;
  }



// WEBPACK FOOTER //
// ./src/features/common/getError.js